import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// utils
import { fNumber } from 'src/utils/format-number';
// components
import Chart from 'src/components/chart';

// ----------------------------------------------------------------------
export default function HeaderAnalytics({ title, total, chart, sx, ...other }) {
    const theme = useTheme();

    return (
      <>
            <Box sx={{ display:'flex', justifyContent: 'start' , alignItems: 'center', width: '100%', gap: 2,}}>
                <Stack direction="row" alignItems="center"></Stack>
                <Typography variant="h4" sx={{color: 'green'}}>{ `$${fNumber(total)}`}</Typography>
            </Box>
            </>
    );
}

HeaderAnalytics.propTypes = {
    chart: PropTypes.object,
    sx: PropTypes.object,
    title: PropTypes.string,
    total: PropTypes.number,
};
